/**
 * Quick Timer Widget
 * Practice timer launcher with preset minute buttons.
 * Moved from StudentDashboardBeta (Phase 3.2 extraction).
 */

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Clock } from 'lucide-react'
import { useTranslation } from '../../i18n/TranslationProvider'

export interface QuickTimerWidgetProps {
  presetsMin: number[]
  className?: string
}

const QuickTimerWidget: React.FC<QuickTimerWidgetProps> = ({ presetsMin, className = '' }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div
      onClick={() => navigate('/tool/timer')}
      className={`bg-white border border-[var(--color-border-light)] rounded-[var(--radius-r)]
                  p-[18px] shadow-[var(--shadow-sh0)]
                  transition-all duration-[.2s]
                  cursor-pointer hover:shadow-[var(--shadow-sh2)] hover:-translate-y-[2px]
                  active:translate-y-0 active:scale-[.99]
                  flex flex-col ${className}`}
    >
      <div className="flex items-center gap-[7px] text-[11px] font-semibold text-[var(--color-text-tertiary)]
                      uppercase tracking-[.5px] mb-[12px]">
        <Clock size={13} />
        {t('student.quick_timer', 'Quick Timer')}
      </div>
      <div className="text-[13px] font-bold text-[var(--color-text-primary)] mb-[8px]">
        {t('student.start_practicing', 'Start practicing')}
      </div>
      <div className="flex gap-[5px] flex-wrap">
        {presetsMin.map(m => (
          <button
            key={m}
            onClick={(e) => {
              e.stopPropagation()
              sessionStorage.setItem('presetMinutes', String(m))
              navigate('/tool/timer')
            }}
            className="px-[12px] py-[5px] bg-[var(--color-card2)] border border-[var(--color-border-light)]
                       rounded-[var(--radius-r-sm)] text-[12px] font-semibold
                       text-[var(--color-text-secondary)] hover:bg-[var(--color-navy2)]
                       hover:text-white hover:border-[var(--color-navy2)]
                       transition-all duration-[.18s]"
          >
            {m}m
          </button>
        ))}
      </div>
    </div>
  )
}

export default QuickTimerWidget
